import { makeAutoObservable } from "mobx";
import { RadioFieldModel, StringFieldModel } from "@/common/commonForms";
import { DCEvent, showGeneralError, thunk } from "@/events/eventsDomain";
import { ProjectCompany } from "@/dbot/common/commonDomain";
import { adminProject } from "@/utils/navigation";
import { projectApi } from "../common/projectApi";

export type DuplicateProjectDialogState = {
  type: "duplicate-project";
  targetCompany: RadioFieldModel<ProjectCompany>;
  projectName: StringFieldModel;
  onSave: DCEvent[];
  onCancel: DCEvent[];
  isSaving?: boolean;
};

export function showDuplicateProjectDialog({
  projectId,
  projectName,
  companies,
}: {
  projectId: string;
  projectName: string;
  companies: ProjectCompany[];
}): DCEvent[] {
  const dialog = makeAutoObservable<DuplicateProjectDialogState>(
    {
      type: "duplicate-project",
      targetCompany: new RadioFieldModel({
        options: companies,
        value: companies.find((x) => x.isMainCompany) ?? companies[0],
        idFn: (x) => x.orgNo,
        labelFn: (x) => ({ translated: x.name }),
        iconFn: () => "buildings",
      }),
      projectName: new StringFieldModel({ value: projectName, required: true }),
      isSaving: undefined,
      onSave: [
        thunk((dispatch) => {
          if (dialog.projectName.validate()) {
            dialog.isSaving = true;
            dispatch([
              projectApi.createProject(
                {
                  orgNo: dialog.targetCompany.value.orgNo,
                  projectName: dialog.projectName.validatedValue,
                  duplicateProjectId: projectId,
                },
                {
                  onSuccess: (res) => [
                    {
                      type: "load-url",
                      url: adminProject({
                        orgNo: dialog.targetCompany.value.orgNo,
                        projectId: res.data.projectId,
                      }),
                      newWindow: true,
                    },
                    { type: "closeDialog" },
                  ],
                  onFailure: () => [{ type: "closeDialog" }, showGeneralError()],
                },
              ),
            ]);
          }
        }),
      ],
      onCancel: [{ type: "closeDialog" }],
    },
    {},
    { autoBind: true },
  );
  return [{ type: "show-dialog", dialog }];
}
